var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2442_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "#D71924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1939 21.8417L16.5647 13.6639L15.9283 12.739L11.9018 6.88909L11.568 6.4043H6.62012L7.82687 8.15792L13.1808 15.9369L13.8172 16.8609L18.1189 23.1111L18.4527 23.5955H23.4006L22.1939 21.8419V21.8417ZM19.0409 22.476L14.5717 15.9826L13.9353 15.0583L8.74936 7.52351H10.9801L15.1741 13.6171L15.8105 14.5414L21.2718 22.476H19.041H19.0409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.935 15.0586L14.5714 15.9829L13.8169 16.861L8.02809 23.5955H6.60059L13.1805 15.9371L13.935 15.0586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8048 6.4043L16.5647 13.6639L15.8102 14.5414L15.1738 13.6171L15.9283 12.739L20.1553 7.81908L21.3773 6.4043H22.8048Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2442_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.2950056537a5ee4e2f882a2fcce602c3.svg";
export { ForwardRef as ReactComponent };